import { isCareCategoryName as isSharedCareCategoryName } from "./category";

export type ProductId = "care" | "booking";

type ResolveProductInput = {
  pathname?: string;
  preferredVerticalId?: string | null;
  businessCategoryName?: string | null;
};

export function isCareCategoryName(name?: string | null): boolean {
  return isSharedCareCategoryName(name);
}

export function resolveProductId({
  pathname,
  preferredVerticalId,
  businessCategoryName,
}: ResolveProductInput): ProductId {
  if (preferredVerticalId === "care" || preferredVerticalId === "booking") {
    return preferredVerticalId;
  }

  if (isCareCategoryName(businessCategoryName)) {
    return "care";
  }

  const normalizedPath = String(pathname || "").toLowerCase();
  if (
    normalizedPath.startsWith("/care") ||
    normalizedPath.includes("/care/")
  ) {
    return "care";
  }

  return "booking";
}
